export default __webpack_public_path__ + "static/media/Flag_of_United_Kingdom.8c3d2102.svg";